<template>
  <v-menu
    v-model="isVisible"
    :transition="transition"
    :location="location"
    :open-on-hover="hoverOpens"
    :close-on-content-click="contentCloses"
    :origin="origin"
    :activator="target">
    <div
      v-bind="contentId"
      ref="popover"
      :class="customClass"
      class="qx-popover">
      <slot name="title" />
      <slot
        ref="popoverContent"
        tabindex="1" />
    </div>
  </v-menu>
</template>

<script>
export default {
  name: 'QxPopover',
  props: {
    target: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      default: '',
    },
    location: {
      type: String,
      default: 'start bottom',
      validator: (value) =>
        [
          'top',
          'start',
          'bottom',
          'end',
          'center',
          'start bottom',
          'bottom center',
          'start center',
          'bottom end',
          'top center',
        ].includes(value),
    },
    origin: {
      type: String,
      default: 'top center',
      validator: (value) => ['top center', 'end center', 'end top', 'bottom center', 'auto'].includes(value),
    },
    transition: {
      type: String,
      default: 'slide-x-transition',
      validator: (value) => ['scale-transition', 'slide-x-transition', 'slide-y-transition'].includes(value),
    },
    hoverOpens: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
    contentCloses: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['shown', 'hidden'],
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    contentId() {
      if (this.id) {
        return {
          id: `${this.id}-content`,
        };
      }
      return {};
    },
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.$emit('shown');
      } else {
        this.$emit('hidden');
      }
    },
  },
};
</script>

<style lang="scss">
.qx-popover {
  background: white;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  .popover-header {
    border: 0;
    background-color: white;
    color: $gray-600;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 1.5;
  }
  &.more-actions {
    padding: 0;
  }
}
</style>
